import { render } from "./SpotBalanceActionGraphWidgetLayout.vue?vue&type=template&id=7b51b4d6"
import script from "./SpotBalanceActionGraphWidgetLayout.vue?vue&type=script&lang=js"
export * from "./SpotBalanceActionGraphWidgetLayout.vue?vue&type=script&lang=js"
script.render = render

export default script